/* eslint-disable */
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import HomeNav from './HomeNav';
import Footer from './Components/Footer/Footer';
import BannerSection from './Components/BannerSection';
import Background, { BackgroundElement } from './Components/Background';
import EmailSection from './Components/EmailSection';
import RoundedButton from '../../Components/RoundedButton/RoundedButton';
import { OpenDemoLink } from '../../Components/Utilities/HelperFunctions';
import {
  XpektorForm,
  FormInput,
  FormTextArea,
  FormButton,
} from '../../Components/XpektorForms/XpektorForms';

// Media
import SwirlyLines1 from '../../Images/Home/swirly_lines_1.png';
import SwirlyLines2 from '../../Images/Home/swirly_lines_2.png';
import LocationImage from '../../Images/Home/office_location.png';

export default function About() {
  const { t } = useTranslation();
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const history = useHistory();

  const sendMessage = (e) => {
    e.preventDefault();

    window.open(`mailto:info@xpektor.se?subject=${subject}&body=${message}`);
  };

  return (
    <div className="xpektor-home">
      <div className="other-intro about-intro">
        <HomeNav />
        <div className="section intro-section">
          <p className="section-title">
            {t('about-page.intro-section.section-title')}
          </p>
          <h1>
            {t('about-page.intro-section.header-top')}
            <br />
            {t('about-page.intro-section.header-bottom')}
          </h1>
          <div className="button-row">
            <RoundedButton
              text={t('shared.read-more')}
              fillCyan
              onClick={() => {
                history.push('/why');
              }}
            />
            <RoundedButton
              text={t('shared.book-demo')}
              onClick={OpenDemoLink}
            />
          </div>
        </div>
      </div>
      <Background color1="#000B4F" color2="#010024">
        <div className="section-with-element">
          <div className="section founder-section">
            <p className="section-title">XPEKTOR</p>
            <h2>{t('about-page.founder-section.header')}</h2>
            <div className="founder-content">
              <p className="section-text">
                {t('about-page.founder-section.founder-content.section-text.0')}
                <br />
                <br />
                {t('about-page.founder-section.founder-content.section-text.1')}
              </p>
            </div>
          </div>
          <BackgroundElement img={SwirlyLines1} yPos={-200} />
        </div>
        <div className="location-section">
          <div className="text-column">
            <h3>{t('about-page.location-section.find-us')}</h3>
            <p className="section-text">
              {t('about-page.location-section.section-text')}
            </p>
          </div>
          <img src={LocationImage} alt="location_image" />
        </div>
        <div className="section-with-element">
          <div className="section">
            <div className="message-section">
              <h3>{t('shared.message-section.header')}</h3>
              <XpektorForm onSubmit={sendMessage}>
                <FormInput
                  label={t('shared.message-section.title')}
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
                <FormTextArea
                  label={t('shared.message-section.message')}
                  rows={6}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <FormButton text={t('shared.message-section.send-message')} />
              </XpektorForm>
            </div>
          </div>
          <BackgroundElement img={SwirlyLines2} yPos={-200} />
        </div>
        <div className="section">
          <EmailSection />
        </div>
      </Background>
      <Background end>
        <BannerSection />
        <Footer darkMode />
      </Background>
    </div>
  );
}
